import { CarouselCatalogItem } from '@/shared/ui/CarouselCatalogItem/ui/CarouselCatalogItem.jsx'
import './ui/CarouselCatalogItem.scss'
export default CarouselCatalogItem
